class productCol extends HTMLElement {
  constructor() {
    super();

    this.quantityInputElements = this.querySelectorAll('quantity-input input');

    this.quantityInputElements.forEach(element => {
      ['change', 'input'].forEach((inputEvent) => {
        element.addEventListener(inputEvent, (e) => this.handleValue(e.target.valueAsNumber));
      })
    });
  }

  /**
   * Handle the values of the quantity inputs
   * @param {Number} valueAsNumber 
   */
  handleValue(valueAsNumber) {
    this.quantityInputElements.forEach(element => element.value = valueAsNumber);
  }
  
}

if(!customElements.get('product-col')) {
  customElements.define('product-col', productCol);
}


// Swiper is imported already
class productDetailSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector('[data-product-detail-swiper]');

    this.swiperOptions = {
      direction: 'horizontal'
    }

    this.init();
  }

  init() {
    window.addEventListener('load', (event) => {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
    });
    Fancybox.bind("[data-fancybox]", {
      animated: false,
      showClass: false
    });
  }
}

if(!customElements.get('product-detail-swiper')) {
  customElements.define('product-detail-swiper', productDetailSwiper);
}

document.addEventListener('sealsubs:subscription_widget_created', function(e) {
  const subscriptiondetails = e.detail;
  
  console.log(subscriptiondetails);

});

